import { styled as materialStyled } from '@mui/material/styles';
import { TextField } from '@mui/material';
import { OtpVerifyStatus } from '../../utils/enums/otp-verify-status.enum';
import { theme } from '../../theme/theme';

export const SquareInputBox = materialStyled(TextField)(({
  verifystatus,
  height,
  width,
}: {
  verifystatus?: OtpVerifyStatus;
  height: string;
  width: string;
}) => {
  let color = '';
  let border = '';

  if (verifystatus === undefined || verifystatus === OtpVerifyStatus.VERIFYING) {
    color = 'inherit';
    border = `1px solid ${theme.palette.shades.whiteBorder2}`;
  } else if (verifystatus === OtpVerifyStatus.VERIFIED) {
    color = theme.palette.common.black;
    border = `1px solid ${theme.palette.success.main} !important`;
  } else {
    color = theme.palette.common.black;
    border = `1px solid ${theme.palette.error.main} !important`;
  }

  return {
    '& .MuiInputBase-root': {
      height,
      width,
      borderRadius: '4px',
      color,
      '& fieldset': {
        border,
      },
      '&:hover fieldset': {
        border,
      },
      '&.Mui-focused fieldset': {
        border:
          verifystatus === undefined || verifystatus === OtpVerifyStatus.VERIFYING
            ? `1px solid ${theme.palette.shades.blueBorder}`
            : border,
      },
    },
    '& .Mui-disabled': {
      color,
      borderRadius: '4px',
      padding: 0,
      height,
      width,
    },
    '& .MuiInputBase-input': {
      textAlign: 'center',
      WebkitTextFillColor: 'inherit',
      fontFamily: 'Inter',
      fontWeight: 400,
      fontSize: '18px',
    },
  };
});
